import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, ReportStatus } from './index';
import { ReportCreateBody } from './create';

export type ReportUpdateData = {
  success: boolean;
};

export type ReportUpdateResponse = ReportUpdateData;

export interface ReportUpdateBody extends Partial<ReportCreateBody> {
  status?: ReportStatus;
}

export interface ReportUpdatePayload {
  id: string;
  body: ReportUpdateBody
}

export const reportUpdate = (payload: ReportUpdatePayload): Action<ReportUpdatePayload> => ({
  type: actions.reportUpdateTrigger.toString(),
  payload,
});

export const reportUpdateClear = (): Action => ({
  type: actions.reportUpdateClear.toString(),
});

export const reportUpdateErrorClear = (): Action => ({
  type: actions.reportUpdateErrorReset.toString(),
});

export function* reportUpdateRequestSaga({ payload }: Action<ReportUpdatePayload>) {
  yield put({
    type: actions.reportUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.reportUpdateError.toString(),
      payload: {
        message: 'ReportUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/reports/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ReportUpdateData, ReportUpdateResponse>(
    response,
    actions.reportUpdateSuccess.toString(),
    actions.reportUpdateError.toString(),
    false,
    (reportUpdateData) => reportUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.reportUpdateTrigger.toString(),
    defaultProcessingSaga(
      reportUpdateRequestSaga,
      {
        error: actions.reportUpdateError.toString(),
        locationCancel: actions.reportUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.reportUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.reportUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.reportUpdateErrorReset.toString(),
    });
  });
}
